module.exports = "/images/advantages.svg?a186a40d7a17baa1f9e7081f60e8660b";